import { Firestore } from 'firebase/firestore';
import { FirebaseApp } from 'firebase/app';
import { Functions } from 'firebase/functions';
import { db, functions } from './config';
import app from './config';

/**
 * Firestore 인스턴스가 초기화되었는지 확인하고 반환합니다.
 *
 * @throws {Error} Firestore가 초기화되지 않은 경우 에러 발생
 * @returns {Firestore} 초기화된 Firestore 인스턴스
 */
export function getDb(): Firestore {
  if (!db) {
    throw new Error('Firestore is not initialized. Please check Firebase configuration.');
  }
  return db;
}

/**
 * Firebase App 인스턴스가 초기화되었는지 확인하고 반환합니다.
 *
 * @throws {Error} Firebase App이 초기화되지 않은 경우 에러 발생
 * @returns {FirebaseApp} 초기화된 Firebase App 인스턴스
 */
export function getFirebaseApp(): FirebaseApp {
  if (!app) {
    throw new Error('Firebase App is not initialized. Please check Firebase configuration.');
  }
  return app;
}

/**
 * Firestore 인스턴스가 사용 가능한지 확인합니다.
 *
 * @returns {boolean} Firestore가 초기화되었으면 true, 아니면 false
 */
export function isDbAvailable(): boolean {
  return db !== null;
}

/**
 * V176: Firebase Functions 인스턴스가 초기화되었는지 확인하고 반환합니다.
 *
 * @throws {Error} Functions가 초기화되지 않은 경우 에러 발생
 * @returns {Functions} 초기화된 Firebase Functions 인스턴스
 */
export function getFunctions(): Functions {
  if (!functions) {
    throw new Error('Firebase Functions is not initialized. Please check Firebase configuration.');
  }
  return functions;
}
